import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UrlSearchValueObject} from '../ValueObjects/UrlSearchValueObject.js'

class GetStockUrlParamsSearchUseCase extends UseCase {
  #config

  constructor({config}) {
    super()
    this.#config = config
  }

  static create({config}) {
    return new GetStockUrlParamsSearchUseCase({config})
  }

  @tracer({metric: 'GetStockUrlParamsSearchUseCase#execute'})
  @AsyncInlineError()
  async execute({dealerSlug, listingSectionId, search}) {
    return UrlSearchValueObject.createFromStockSearch({
      config: this.#config,
      dealerSlug,
      listingSectionId,
      search
    })
  }
}

export const factory = GetStockUrlParamsSearchUseCase.create
